import React from "react";
import { Modal, Input, Select, Checkbox, message } from "antd";

const { Option } = Select;

const AddressModal = ({ visible, onClose, formData, setFormData, onSave }) => {
  const handleChange = (key, value) => {
    setFormData({ ...formData, [key]: value });
  };

  const handleSave = () => {
    const requiredFields = [
      "addressLine1",
      "city",
      "state",
      "pinCode",
      "country",
      "mobileNumber",
      "type",
    ];

    for (const field of requiredFields) {
      if (!formData[field]) {
        message.error(`Please enter ${field.replace(/([A-Z])/g, " $1")}`);
        return;
      }
    }

    if (!/^[6-9]\d{9}$/.test(formData.mobileNumber)) {
      message.error("Please enter a valid 10-digit mobile number");
      return;
    }

    onSave();
  };

  return (
    <Modal
      title="Add New Address"
      visible={visible}
      onCancel={onClose}
      onOk={handleSave}
      okText="Save"
      cancelText="Cancel"
    >
      <div className="modal-form">
        <label>Address Line 1</label>
        <Input
          placeholder="Address Line 1"
          value={formData.addressLine1}
          onChange={(e) => handleChange("addressLine1", e.target.value)}
        />

        <label>Address Line 2</label>
        <Input
          placeholder="Address Line 2"
          value={formData.addressLine2}
          onChange={(e) => handleChange("addressLine2", e.target.value)}
        />

        <label>City</label>
        <Input
          placeholder="City"
          value={formData.city}
          onChange={(e) => handleChange("city", e.target.value)}
        />

        <label>State</label>
        <Input
          placeholder="State"
          value={formData.state}
          onChange={(e) => handleChange("state", e.target.value)}
        />

        <label>Pincode</label>
        <Input
          placeholder="Pin Code"
          value={formData.pinCode}
          onChange={(e) => handleChange("pinCode", e.target.value)}
        />

        <label>Country</label>
        <Input
          placeholder="Country"
          value={formData.country}
          onChange={(e) => handleChange("country", e.target.value)}
        />

        <label>Mobile Number</label>
        <Input
          placeholder="10-digit mobile number"
          value={formData.mobileNumber}
          onChange={(e) => handleChange("mobileNumber", e.target.value.replace(/\D/g, "").slice(0, 10))}
          maxLength={10}
          type="tel"
        />

        <label>Address Type</label>
        <Select
          value={formData.type}
          onChange={(value) => handleChange("type", value)}
          style={{ width: "100%" }}
        >
          <Option value="HOME">Home</Option>
          <Option value="OFFICE">Office</Option>
        </Select>

        <Checkbox
          checked={formData.default}
          onChange={(e) => handleChange("default", e.target.checked)}
        >
          Default Address
        </Checkbox>
      </div>
    </Modal>
  );
};

export default AddressModal;
